import { Injectable, TemplateRef } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ModalWrapperComponent } from "app/components/modal-wrapper/modal-wrapper.component";

export interface AppModalOptions {
  title?: string;
  titleClass?: string;
  subtitle?: string;
  icon?: string;
  iconSize?: number;
  iconColor?: string;
  showClose?: boolean;
  noBorder?: boolean;
  bodyClass?: string;
  footerClass?: string;
  footerTemplate?: TemplateRef<any>;
  hasBodyWrapper?: boolean;
  container?: string | HTMLElement;
  backdrop?: boolean | "static";
  centered?: boolean;
  keyboard?: boolean;
  windowClass?: string;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class ModalService {
  constructor(protected modalService: NgbModal) {}

  open(
    modal: any,
    sizeOrOptions: "sm" | "md" | "lg" | "xl" | "lg-xl" | string | AppModalOptions = "md",
    options?: AppModalOptions
  ): NgbModalRef {
    let size: string = "md";
    let opts: AppModalOptions = {};

    if (typeof sizeOrOptions === "object" && sizeOrOptions !== null) {
      opts = sizeOrOptions;
      size = (opts.size as string) || "md";
    } else {
      size = typeof sizeOrOptions === "string" && sizeOrOptions ? sizeOrOptions : "md";
      opts = options || {};
    }

    const container = opts?.container || (document.fullscreenElement as HTMLElement) || "body";
    const ngbOptions = {
      centered: opts?.centered !== undefined ? opts.centered : true,
      size: size,
      backdrop: opts && opts.backdrop !== undefined ? opts.backdrop : "static",
      keyboard: opts?.keyboard !== undefined ? opts.keyboard : true,
      container: container as any,
      ...opts,
    };

    // Nếu có opts.title và modal là TemplateRef -> tự động bọc ModalWrapperComponent
    if (opts?.title && modal instanceof TemplateRef) {
      const modalRef = this.modalService.open(ModalWrapperComponent, ngbOptions);
      const instance = modalRef.componentInstance as ModalWrapperComponent;
      instance.title = opts.title;
      instance.titleClass = opts.titleClass || '';
      instance.subtitle = opts.subtitle;
      instance.icon = opts.icon;
      instance.iconSize = opts.iconSize || 18;
      instance.iconColor = opts.iconColor;
      instance.showClose = opts.showClose !== false;
      instance.noBorder = opts.noBorder || false;
      instance.bodyClass = opts.bodyClass || "";
      instance.footerClass = opts.footerClass || "";
      instance.hasBodyWrapper = opts.hasBodyWrapper !== false;
      instance.contentTemplate = modal;
      instance.footerTemplate = opts.footerTemplate;
      return modalRef;
    }

    return this.modalService.open(modal, ngbOptions);
  }

  close(modalRef: NgbModalRef): void {
    modalRef.dismiss();
  }

  dismiss(modalRef: NgbModalRef): void {
    modalRef.dismiss();
  }

  closeAll(): void {
    this.modalService.dismissAll();
  }
}
